(function() {
    'use strict';

    angular
        .module('atheer.job', [

        ]);
})();
